import React from 'react';
import Components from './components/Components';
import ScrolToTop from './components/Elements/ScrolToTop';
import { SiteContentProvider } from './content/SiteContentContext';

const App = () => {
  
  return (
    <div className="App">
      <SiteContentProvider>
        <Components />
        <ScrolToTop/>
      </SiteContentProvider>
    </div>
  );
}

export default App;
